import axios from "axios";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const autoAssignService = {
    list: async () => axios.get(API_KEEPER + "/auto/assign/plates/getAll").then(({ data }) => data).catch((err) => { throw err }),

    getById: async (id) => axios.get(API_KEEPER + `/auto/assign/plates/getById/${id}`).then(({ data }) => data).catch((err) => { throw err }),

    signedAlarms: async (id, params) => axios.get(API_KEEPER + `/auto/assign/plates/alarms/${id}`, { params: params ?? {} }).then(({ data }) => data).catch((err) => { throw err }), 

    create: async (payload) => axios.post(API_KEEPER + "/auto/assign/plates/create", payload).then(({ data }) => data).catch((err) => { throw err }),

    update: async (id, payload) => axios.put(API_KEEPER + `/auto/assign/plates/update/${id}`, payload).then(({ data }) => data).catch((err) => { throw err }),

    remove: async (id) => axios.delete(API_KEEPER + `/auto/assign/plates/delete/${id}`).then(({ data }) => data).catch((err) => { throw err }),
};

export default autoAssignService;